import parse, { Element } from "html-react-parser";

import TextLink from "@/components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "@/components/TextLink/types";

export const useParseHtmlContent = () => {
  const parseContent = (content: string) => {
    return parse(content, {
      replace: domNode => {
        if (
          domNode instanceof Element &&
          domNode.name === "a" &&
          domNode.attribs?.href
        ) {
          const textNode = domNode.children?.[0];
          const text = textNode && "data" in textNode ? textNode.data : "";
          return (
            <TextLink
              isIcon
              target="_blank"
              href={domNode.attribs.href}
              size={TEXT_LINK_SIZES.Normal}
            >
              {text}
            </TextLink>
          );
        }
      }
    });
  };

  return { parseContent };
};
